export class MapConstants {
  static MAP_Token =
    'pk.eyJ1IjoiY3N4LXRlY2hub2xvZ3kiLCJhIjoiY204bjNwMWs3MWlhOTJscHQwa3F6M3d4ayJ9.oBUOSeo6qgwreg5rDtxfTw';
  static MAP_STYLE_LIGHT =
    'mapbox://styles/csx-technology/cm98ignc5000i01s01y3hcshx';
  static MAP_STYLE_Dark =
    'mapbox://styles/csx-technology/cm98ignbq006j01qp84c16org';
  static MAP_STYLE_Road =
    'mapbox://styles/csx-technology/cm98ign5p006i01qp0jz86huj';
  public static DEFAULT_ZOOM: number = 4.45;
  public static BOUNDS = [
    [-124.3, 18.09], // Southwest coordinates
    [-56.93, 52.15] // Northeast coordinates
  ];
  //level-1 dashboard map default center
  static LONGITUDE = -80.8518;
  static LATITUDE = 36.0;
  //level-3 "Map" tab default center (previous/original coordinates)
  static LEVEL3_LONGITUDE = -88.1518;
  static LEVEL3_LATITUDE = 35.9093;
  static MOBILE_LONGITUDE = -83.1518;
  static MOBILE_LATITUDE = 35.9093;
  //terminal dot colors based on avg turn time vs app config threshold (iohGateAvgTurnTimeMints)
  static TERMINAL_DOT_COLOR_GOOD = '#58c56c';
  static TERMINAL_DOT_COLOR_BAD = '#ef655e';
  static TERMINAL_DOT_COLOR_DEFAULT = '#f4f72f';
  static DISPLAY_NONE = ['CSX Yard Point', 'Engineering Milepost'];

  static DISPLAY_LABELS_ZOOM = 7;

  static DISPLAY_NONE_OP = [
    ...MapConstants.DISPLAY_NONE,
    'CSX Region Area',
    'CSX Zone Area',
    'CSX Zone Area Boundary',
    'High Threat Urban Areas Label',
    'High Threat Urban Areas'
  ];

  //base style layer ids for the blue CSX rail/track network lines - only hidden on the level-1 dashboard preview (terminals only), kept visible on level-3
  static CSX_TRACK_LAYERS = [
    'CSAO Owned',
    'CSAO Detail',
    'CSAO Zoomed',
    'CSX Track Detail',
    'CSX Track Label',
    'CSX Subdivision',
    'CSX Sub Label',
    'CSX Leased Detail',
    'CSX Leased Zoomed',
    'CSX Op Agmt Detail',
    'CSX Op Agmt Zoomed copy',
    'CSX Partial Owned',
    'CSX Owned',
    'Non-CSX Track - Short Line',
    'Non-CSX Track - Short Line Label',
    'Non-CSX Track - Class 1'
  ];

  static popupOffset() {
    const markerHeight = 50;
    const markerRadius = 10;
    const linearOffset = 50;
    let popupOffsets = {
      top: [0, 0],
      'top-left': [0, 0],
      'top-right': [0, 0],
      bottom: [-50, markerHeight],
      'bottom-left': [
        linearOffset,
        (markerHeight - markerRadius + linearOffset) * -1
      ],
      'bottom-right': [
        -linearOffset,
        (markerHeight - markerRadius + linearOffset) * -1
      ],
      left: [markerRadius, (markerHeight - markerRadius) * -1],
      right: [-markerRadius, (markerHeight - markerRadius) * -1]
    };
    return popupOffsets;
  }

  public static INTERMODALMAP_LS_ID = 'train';
  public static INTERMODALMAP_LABEL_ID = 'train-label';

  public static INTERMODALMAP_TERMINALS_SOURCE_ID = 'ioh-terminals';
  public static INTERMODALMAP_TERMINALS_HALO_ID = 'ioh-terminals-halo';
  public static INTERMODALMAP_TERMINALS_DOT_ID = 'ioh-terminals-dot';
  public static INTERMODALMAP_TERMINALS_LABEL_ID = 'ioh-terminals-label';

  //soft outer glow, matches the level-1 dashboard preview map's status dot design
  public static INTERMODALMAP_TERMINALS_HALO_LAYER = {
    id: MapConstants.INTERMODALMAP_TERMINALS_HALO_ID,
    type: 'circle' as const,
    source: MapConstants.INTERMODALMAP_TERMINALS_SOURCE_ID,
    paint: {
      'circle-radius': 15,
      'circle-color': ['coalesce', ['get', 'dotColor'], MapConstants.TERMINAL_DOT_COLOR_DEFAULT],
      'circle-opacity': 0.5,
      'circle-blur': 1
    }
  };

  public static INTERMODALMAP_TERMINALS_DOT_LAYER = {
    id: MapConstants.INTERMODALMAP_TERMINALS_DOT_ID,
    type: 'circle' as const,
    source: MapConstants.INTERMODALMAP_TERMINALS_SOURCE_ID,
    paint: {
      'circle-radius': 6,
      'circle-color': ['coalesce', ['get', 'dotColor'], MapConstants.TERMINAL_DOT_COLOR_DEFAULT],
      'circle-stroke-width': 0
    }
  };

  public static INTERMODALMAP_TERMINALS_LABEL_LAYER = {
    id: MapConstants.INTERMODALMAP_TERMINALS_LABEL_ID,
    type: 'symbol' as const,
    source: MapConstants.INTERMODALMAP_TERMINALS_SOURCE_ID,
    layout: {
      'text-field': ['get', 'terminalCode'],
      'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
      'text-size': 12,
      'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
      'text-radial-offset': 0.8,
      'text-padding': 3,
      'text-allow-overlap': false,
      'text-ignore-placement': false
    },
    paint: {
      'text-color': '#ffffff',
      'text-halo-color': '#202221',
      'text-halo-width': 1.5
    }
  };

  public static INTERMODALMAP_TRAIN_LAYER = {
    id: MapConstants.INTERMODALMAP_LS_ID,
    type: 'symbol',
    source: MapConstants.INTERMODALMAP_LS_ID,
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': [
        'let',
        'trainStatus',
        ['get', 'trainStoppedStarted'],
        'perfClass',
        ['get', 'performanceClassification'],
        'headingVal',
        ['get', 'heading'],
        [
          'case',
          ['==', ['var', 'trainStatus'], 'TRAIN_MOVEMENT_STOPPED'],
          [
            'match',
            ['var', 'perfClass'],
            'PERFORMANCE_CLASSIFICATION_DELAYED',
            'yellowCross-v1',
            'PERFORMANCE_CLASSIFICATION_AHEAD_OF_TIME',
            'greenCross-v1',
            'PERFORMANCE_CLASSIFICATION_LATE',
            'redCross-v1',
            'PERFORMANCE_CLASSIFICATION_EARLY',
            'blueCross-v1',
            'green'
          ],

          ['==', ['var', 'headingVal'], 'null'],
          [
            'match',
            ['var', 'perfClass'],
            'PERFORMANCE_CLASSIFICATION_LATE',
            'red-v1',
            'PERFORMANCE_CLASSIFICATION_EARLY',
            'blue-v1',
            'PERFORMANCE_CLASSIFICATION_DELAYED',
            'yellow-v1',
            'PERFORMANCE_CLASSIFICATION_AHEAD_OF_TIME',
            'green-v1',
            'green'
          ],

          ['==', ['var', 'headingVal'], 0],
          [
            'match',
            ['var', 'perfClass'],
            'PERFORMANCE_CLASSIFICATION_LATE',
            'red-v1',
            'PERFORMANCE_CLASSIFICATION_EARLY',
            'blue-v1',
            'PERFORMANCE_CLASSIFICATION_DELAYED',
            'yellow-v1',
            'PERFORMANCE_CLASSIFICATION_AHEAD_OF_TIME',
            'green-v1',
            'green'
          ],

          [
            'match',
            ['var', 'perfClass'],
            'PERFORMANCE_CLASSIFICATION_LATE',
            'redCircle-v1',
            'PERFORMANCE_CLASSIFICATION_EARLY',
            'blueCircle-v1',
            'PERFORMANCE_CLASSIFICATION_DELAYED',
            'yellowCircle-v1',
            'PERFORMANCE_CLASSIFICATION_AHEAD_OF_TIME',
            'greenCircle-v1',
            'green'
          ]
        ]
      ],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 0, 0.42, 10, 0.8],
      'icon-allow-overlap': true,
      'icon-pitch-alignment': 'map',
      'icon-rotation-alignment': 'map',
      'icon-rotate': [
        'case',
        ['!=', ['get', 'trainStoppedStarted'], 'TRAIN_MOVEMENT_STOPPED'],
        ['get', 'heading'],
        0
      ]
    },
    paint: {
      'icon-halo-color': 'hsl(100,100%,100%)',
      'icon-halo-width': 2
    }
  };

  public static INTERMODALMAP_TRAIN_LABEL__DARK_LAYER = {
    id: MapConstants.INTERMODALMAP_LABEL_ID,
    type: 'symbol',
    source: MapConstants.INTERMODALMAP_LS_ID,
    filter: [
      'any',
      ['get', 'customUrl'],
      [
        'all',
        ['>=', ['zoom'], MapConstants.DISPLAY_LABELS_ZOOM],
        ['!=', ['get', 'showLabels'], false]
      ],
      ['all', ['<', ['zoom'], 7], ['==', ['get', 'showLabels'], true]]
    ],
    layout: {
      'icon-image': ['get', 'iconImage'],
      'icon-size': [
        'case',
        [
          'any',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_1'
          ]
        ],
        0.9,
        1
      ],
      'icon-offset': [55, 0],
      'icon-allow-overlap': false,
      'text-field': [
        'format',
        ['get', 'firstPart'],
        { 'text-color': ['get', 'firstPartColor'] },
        ' ',
        ['get', 'middlePart'],
        { 'text-color': ['get', 'middlePartColor'] },
        ' ',
        ['get', 'lastPart'],
        { 'text-color': '#fff' },
        ' ',
        [
          'case',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_2'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_3'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_4'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_5'
          ],
          'l',
          ''
        ],
        { 'text-color': '#656769' },
        [
          'case',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_3'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_4'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_5'
          ],
          'l',
          ''
        ],
        { 'text-color': '#919393' },
        [
          'case',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_4'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_5'
          ],
          'l',
          ''
        ],
        { 'text-color': '#BDBEBF' },
        [
          'case',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_5'
          ],
          'l',
          ''
        ],
        { 'text-color': '#d3d4d4' }
      ],
      'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
      'text-size': 13,
      'text-anchor': 'left',
      'text-allow-overlap': false,
      'text-radial-offset': 2,
      'text-justify': 'auto',
      'text-max-width': 10
    },

    paint: {
      'text-color': '#ffffff',
      'text-halo-color': '#232628',
      'text-halo-width': 1.5,
      'text-halo-blur': 0,
      'text-opacity': 1
    }
  };

  public static INTERMODALMAP_TRAIN_LABEL__LIGHT_LAYER = {
    id: MapConstants.INTERMODALMAP_LABEL_ID,
    type: 'symbol' as const,
    source: MapConstants.INTERMODALMAP_LS_ID,
    filter: [
      'any',
      ['get', 'customUrl'],
      ['all', ['>=', ['zoom'], 7], ['!=', ['get', 'showLabels'], false]],
      ['all', ['<', ['zoom'], 7], ['==', ['get', 'showLabels'], true]]
    ],
    layout: {
      'icon-image': ['get', 'iconLightImage'],
      'icon-size': [
        'case',
        [
          'any',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_1'
          ]
        ],
        0.9,
        1
      ],
      'icon-allow-overlap': false,
      'icon-offset': [55, 0],
      'text-field': [
        'format',
        ['get', 'firstPart'],
        {
          'text-color': [
            'case',
            [
              '==',
              ['get', 'crewHoursOfService'],
              'HOURS_OF_SERVICE_MORE_THAN_4_FILTER'
            ],
            '#b3cdfb',
            [
              '==',
              ['get', 'crewHoursOfService'],
              'HOURS_OF_SERVICE_LESS_THAN_EQUAL_TO_4'
            ],
            '#e33a31',
            'black'
          ]
        },
        ' ',
        ['get', 'middlePart'],
        {
          'text-color': [
            'case',
            [
              '==',
              ['get', 'performanceClassification'],
              'PERFORMANCE_CLASSIFICATION_LATE'
            ],
            '#e33a31',
            [
              '==',
              ['get', 'performanceClassification'],
              'PERFORMANCE_CLASSIFICATION_EARLY'
            ],
            '#2F6EF7',
            [
              '==',
              ['get', 'performanceClassification'],
              'PERFORMANCE_CLASSIFICATION_DELAYED'
            ],
            '#ffbd33',
            [
              '==',
              ['get', 'performanceClassification'],
              'PERFORMANCE_CLASSIFICATION_AHEAD_OF_TIME'
            ],
            '#15c154',
            'black'
          ]
        },
        ' ',
        ['get', 'lastPart'],
        { 'text-color': 'black' },
        '\u00A0',
        [
          'case',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_2'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_3'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_4'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_5'
          ],
          'l',
          ''
        ],
        { 'text-color': '#656769' },
        [
          'case',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_3'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_4'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_5'
          ],
          'l',
          ''
        ],
        { 'text-color': '#919393' },
        [
          'case',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_4'
          ],
          'l',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_5'
          ],
          'l',
          ''
        ],
        { 'text-color': '#BDBEBF' },
        [
          'case',
          [
            '==',
            ['get', 'reportedLengthClassification'],
            'REPORTED_LENGTH_CLASSIFICATION_5'
          ],
          'l',
          ''
        ],
        { 'text-color': '#d3d4d4' }
      ],
      'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
      'text-size': 13,
      'text-anchor': 'left',
      'text-allow-overlap': false,
      'text-justify': 'auto',
      'text-max-width': 10,
      'text-radial-offset': [
        'case',
        [
          'any',
          ['==', ['get', 'lorCrewHosInd'], ''],
          ['==', ['get', 'lorCrewHosInd'], 'D']
        ],
        1.9,
        2
      ]
    },
    paint: {
      'text-color': '#000000',
      'text-halo-color': 'hsl(100,100%,100%)',
      'text-halo-width': 5,
      'text-halo-blur': 0,
      'text-opacity': 1
    }
  };
}
